/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.ButtonPalette";
        const ROOT_CLASS = "button-palette-root";
        const HORIZONTAL_CLASS = "button-palette-root--horizontal";
        const VERTICAL_CLASS = "button-palette-root--vertical";
        const OPTION_CLASS = "button-palette-option";
        const OPTION_TILE_CLASS = "button-palette-option--tile";
        const OPTION_ID_ATTRIBUTE = "button-palette-option-id";
        const OPTION_BUTTON_CLASS = "button-palette-option__button";
        const BUTTON_TEXT_CLASS = "wpt-button__text";
        const OPTION_BUTTON_LABEL_CLASS = "button-palette-option__button-label";
        const OPTION_BUTTON_ICON_CLASS = "button-palette-option__button-icon";
        const TILE_CONTAINER_CLASS = "button-palette-option__tile";
        const TILE_CONTENT_CLASS = "button-palette-option__tile-content";
        const TILE_LABEL_CLASS = "button-palette-option__tile-label";
        const TILE_DESC_CLASS = "button-palette-option__tile-description";
        class ComponentButtonPalette extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config, callback = null) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = false;
                this._displayedCallback = null;
                // UI Chunks
                this._buttonHolder = null;
                this._noItems = null;
                // Data
                this._options = [];
                this.clearOptionSelection = () => {
                    this._log.info("ButtonPaletteComponent.clearOptionSelection()");
                    // ignore if not ready
                    if (!this._componentReady)
                        return;
                    let selectedOptions = this._buttonHolder.querySelectorAll('.' + OPTION_CLASS + '.' + Widgets.WIDGET_SELECTED_CLASS);
                    selectedOptions.forEach(option => {
                        option.classList.remove(Widgets.WIDGET_SELECTED_CLASS);
                    });
                };
                this.selectOption = (id) => {
                    this._log.info("ButtonPaletteComponent.selectOption()");
                    // ignore if not ready
                    if (!this._componentReady)
                        return;
                    let option = this._buttonHolder.querySelector('.' + OPTION_CLASS + '[' + OPTION_ID_ATTRIBUTE + '="' + id + '"]');
                    option.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                };
                this.filterOptions = (search) => {
                    this._log.info("ButtonPaletteComponent.filterOptions()");
                    // ignore if not ready
                    if (!this._componentReady)
                        return;
                    let options = this._buttonHolder.querySelectorAll('.' + OPTION_CLASS);
                    options.forEach(option => {
                        let label = option.querySelector('.' + OPTION_BUTTON_LABEL_CLASS);
                        if (option.classList.contains(Widgets.WIDGET_SELECTED_CLASS) || label.innerText.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                            option.style.display = "";
                        }
                        else {
                            option.style.display = "none";
                        }
                    });
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("ButtonPaletteComponent._storeHtml()");
                    ComponentButtonPalette.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this.displayOptions = (options, displayedCallback = null) => {
                    this._log.info("ButtonPaletteComponent.displayOptions()");
                    this._options = options;
                    this._displayedCallback = displayedCallback;
                    if (this._componentReady)
                        this._drawDisplay();
                    else
                        this._displayPending = true;
                };
                this.clearDisplay = () => {
                    this._log.info("ButtonPaletteComponent.clearDisplay()");
                    this._options = [];
                    if (this._componentReady) {
                        this._buttonHolder.innerHTML = '';
                    }
                };
                this._drawDisplay = () => {
                    this._log.info("ButtonPaletteComponent._drawDisplay()");
                    this._buttonHolder.innerHTML = '';
                    // Count the visible options
                    let visibleOptions = 0;
                    if (!this._options || (this._options.length == 0)) {
                        if (!this._config.SuppressNoItemsBanner)
                            this._core.Functions.showElement(this._noItems);
                        if (this._displayedCallback)
                            this._displayedCallback(0);
                        return;
                    }
                    let fragment = document.createDocumentFragment();
                    let rootNode = document.createElement('ul');
                    rootNode.classList.add(ROOT_CLASS);
                    fragment.appendChild(rootNode);
                    // Initial styling
                    if (this._config.Orientation == 'Horizontal') {
                        rootNode.classList.add(HORIZONTAL_CLASS);
                    }
                    else {
                        rootNode.classList.add(VERTICAL_CLASS);
                    }
                    // Loop and display
                    this._options.forEach(option => {
                        let hidden = (option.hasOwnProperty('Hidden') && option.Hidden);
                        // Build the items
                        switch (this._config.Type) {
                            case 'Tiles':
                                let tileItem = this._createItem(option, true);
                                rootNode.appendChild(tileItem);
                                if (hidden)
                                    tileItem.classList.add(WPTNamespace.HIDDEN_CLASS);
                                else
                                    visibleOptions++;
                                break;
                            case 'Buttons':
                            default:
                                let item = this._createItem(option);
                                rootNode.appendChild(item);
                                if (hidden)
                                    item.classList.add(WPTNamespace.HIDDEN_CLASS);
                                else
                                    visibleOptions++;
                                break;
                        }
                    });
                    this._buttonHolder.appendChild(fragment);
                    if (visibleOptions)
                        this._core.Functions.hideElement(this._noItems);
                    else if (!this._config.SuppressNoItemsBanner)
                        this._core.Functions.showElement(this._noItems);
                    if (this._displayedCallback)
                        this._displayedCallback(visibleOptions);
                };
                this._createItem = (option, asTile = false) => {
                    this._log.info("ButtonPaletteComponent._createItem()");
                    let item = document.createElement('li');
                    item.classList.add(OPTION_CLASS);
                    item.setAttribute(OPTION_ID_ATTRIBUTE, option.Identifier);
                    let button = document.createElement('button');
                    item.appendChild(button);
                    button.setAttribute(OPTION_ID_ATTRIBUTE, option.Identifier);
                    button.classList.add('wpt-button', 'wpt-button--full', OPTION_BUTTON_CLASS);
                    if (this._config.UsePrimaryColour) {
                        button.classList.add('wpt-button--primary');
                    }
                    else {
                        button.classList.add('wpt-button--accent');
                    }
                    let iconRoot = button;
                    let labelRoot = button;
                    let tileDiv = null;
                    let contentDiv = null;
                    let labelDiv = null;
                    if (asTile) {
                        item.classList.add(OPTION_TILE_CLASS);
                        tileDiv = document.createElement('div');
                        button.appendChild(tileDiv);
                        tileDiv.classList.add(TILE_CONTAINER_CLASS);
                        contentDiv = document.createElement('div');
                        tileDiv.appendChild(contentDiv);
                        contentDiv.classList.add(TILE_CONTENT_CLASS);
                        iconRoot = contentDiv;
                        labelDiv = document.createElement('div');
                        tileDiv.appendChild(labelDiv);
                        labelDiv.classList.add(TILE_LABEL_CLASS);
                        labelRoot = labelDiv;
                    }
                    if (option.hasOwnProperty('Icon') && option.Icon) {
                        let iconDiv = document.createElement('div');
                        iconRoot.appendChild(iconDiv);
                        iconDiv.classList.add(OPTION_BUTTON_ICON_CLASS);
                        if (option.Icon.Background) {
                            iconDiv.style.backgroundColor = option.Icon.Background;
                        }
                        if (option.Icon.CellHeight) {
                            iconDiv.style.height = option.Icon.CellHeight;
                        }
                        if (option.Icon.CellWidth) {
                            iconDiv.style.width = option.Icon.CellWidth;
                        }
                        if (option.Icon.hasOwnProperty('URL')) {
                            let imageIcon = option.Icon;
                            let img = document.createElement('img');
                            iconDiv.appendChild(img);
                            img.src = imageIcon.URL;
                            if (imageIcon.ImageHeight) {
                                img.height = imageIcon.ImageHeight;
                            }
                            if (imageIcon.ImageWidth) {
                                img.width = imageIcon.ImageWidth;
                            }
                            if (imageIcon.MaxHeight) {
                                img.style.maxHeight = imageIcon.MaxHeight;
                            }
                            if (imageIcon.MaxWidth) {
                                img.style.maxWidth = imageIcon.MaxWidth;
                            }
                        }
                        else if (option.Icon.hasOwnProperty('Classes')) {
                            let fontIcon = option.Icon;
                            let iconSpan = document.createElement('span');
                            iconDiv.appendChild(iconSpan);
                            iconSpan.classList.add(...fontIcon.Classes.split(" "));
                            if (fontIcon.FontColour) {
                                iconSpan.style.color = fontIcon.FontColour;
                            }
                            if (fontIcon.FontSize) {
                                iconSpan.style.fontSize = fontIcon.FontSize;
                            }
                        }
                        else {
                            if (!option.Icon.CellHeight) {
                                iconDiv.style.height = "1em";
                            }
                            if (!option.Icon.CellWidth) {
                                iconDiv.style.width = "1em";
                            }
                        }
                    }
                    let btnLabel = (option.hasOwnProperty('Label') && option.Label) ? option.Label : option.Identifier;
                    btnLabel = this._core.Locale.getTranslation(btnLabel);
                    let labelSpan = document.createElement('span');
                    labelRoot.appendChild(labelSpan);
                    labelSpan.classList.add(BUTTON_TEXT_CLASS, OPTION_BUTTON_LABEL_CLASS);
                    labelSpan.innerText = btnLabel;
                    labelSpan.setAttribute('title', btnLabel);
                    if (asTile) {
                        let tileSettings = {};
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("starting with: " + JSON.stringify(tileSettings));
                        }
                        if (this._config.hasOwnProperty('TileSettings') && this._config.TileSettings) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using config setting: " + JSON.stringify(this._config.TileSettings));
                            }
                            tileSettings = JSON.parse(JSON.stringify(this._config.TileSettings));
                        }
                        if (option.hasOwnProperty('TileSettings') && option.TileSettings) {
                            let override = option.TileSettings;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using override: " + JSON.stringify(override));
                            }
                            // override individual settings
                            for (let setting in override) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("looking at: " + setting);
                                }
                                if (override.hasOwnProperty(setting)) {
                                    if (this._log.isTraceEnabled()) {
                                        this._log.trace("overriding '" + setting + "' (" + tileSettings[setting] + ") with: " + override[setting]);
                                    }
                                    tileSettings[setting] = override[setting];
                                }
                            }
                        }
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using setting: " + JSON.stringify(tileSettings));
                        }
                        if (tileSettings.hasOwnProperty('SuppressLabel') && tileSettings.SuppressLabel) {
                            this._core.Functions.hideElement(labelDiv);
                        }
                        if (tileSettings.hasOwnProperty('Background') && tileSettings.Background) {
                            button.style.backgroundColor = tileSettings.Background;
                        }
                        if (tileSettings.hasOwnProperty('FontColour') && tileSettings.FontColour) {
                            button.style.color = tileSettings.FontColour;
                        }
                        if (tileSettings.hasOwnProperty('MaxHeight') && tileSettings.MaxHeight) {
                            let bp = this;
                            let resizeObserver = new ResizeObserver(entries => {
                                let tileHeight = bp._core.Functions.getCompleteElementHeight(tileDiv);
                                let labelHeight = bp._core.Functions.getCompleteElementHeight(labelDiv);
                                if (tileHeight > 0 && labelHeight <= tileHeight) {
                                    contentDiv.style.maxHeight = (tileHeight - labelHeight) + "px";
                                }
                            });
                            resizeObserver.observe(tileDiv);
                            button.style.maxHeight = tileSettings.MaxHeight;
                        }
                        if (tileSettings.hasOwnProperty('MinHeight') && tileSettings.MinHeight) {
                            button.style.minHeight = tileSettings.MinHeight;
                        }
                        if (tileSettings.hasOwnProperty('MaxWidth') && tileSettings.MaxWidth) {
                            button.style.maxWidth = tileSettings.MaxWidth;
                        }
                        if (tileSettings.hasOwnProperty('MinWidth') && tileSettings.MinWidth) {
                            button.style.minWidth = tileSettings.MinWidth;
                        }
                        if (tileSettings.hasOwnProperty('Description') && tileSettings.Description) {
                            let descDiv = document.createElement('div');
                            contentDiv.appendChild(descDiv);
                            descDiv.classList.add(TILE_DESC_CLASS);
                            descDiv.innerText = tileSettings.Description;
                            if (tileSettings.hasOwnProperty('DescBackground') && tileSettings.DescBackground) {
                                descDiv.style.backgroundColor = tileSettings.DescBackground;
                            }
                            if (tileSettings.hasOwnProperty('DescFontColour') && tileSettings.DescFontColour) {
                                descDiv.style.color = tileSettings.DescFontColour;
                            }
                        }
                    }
                    button.addEventListener('click', this._optionClicked);
                    return item;
                };
                this.hideOption = (identifier) => {
                    this._log.info("ButtonPaletteComponent.hideOption()");
                    this._showHideOption(identifier, false);
                    // Need to detect any still-visible options
                    let optionItem = this._buttonHolder.querySelector('.' + OPTION_CLASS + ':not(.' + WPTNamespace.HIDDEN_CLASS + ')');
                    if (!optionItem && !this._config.SuppressNoItemsBanner)
                        this._core.Functions.showElement(this._noItems);
                };
                this.showOption = (identifier) => {
                    this._log.info("ButtonPaletteComponent.showOption()");
                    this._showHideOption(identifier, true);
                    this._core.Functions.hideElement(this._noItems);
                };
                this._showHideOption = (identifier, show) => {
                    this._log.info("ButtonPaletteComponent._showHideOption()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`called for id '${identifier}'`);
                    }
                    let optionItem = this._buttonHolder.querySelector('.' + OPTION_CLASS + '[' + OPTION_ID_ATTRIBUTE + '="' + identifier + '"]');
                    if (optionItem) {
                        if (show)
                            this._core.Functions.showElement(optionItem);
                        else
                            this._core.Functions.hideElement(optionItem);
                    }
                };
                this._optionClicked = (event) => {
                    this._log.info("ButtonPaletteComponent._optionClicked()");
                    let clickedItem = event.currentTarget;
                    let optionId = clickedItem.getAttribute(OPTION_ID_ATTRIBUTE);
                    if (this._selectCallback)
                        this._selectCallback(optionId);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ButtonPaletteComponent::constructor");
                // Configuration moved from base class so we can type it correctly
                this._config = config;
                if (this._config == null)
                    this._config = {};
                if (!this._config.hasOwnProperty('Type') || (!this._config.Type))
                    this._config.Type = 'Buttons';
                if (!this._config.hasOwnProperty('Orientation') || (!this._config.Orientation))
                    this._config.Orientation = 'Vertical';
                if (!this._config.hasOwnProperty('SuppressNoItemsBanner') || (this._config.SuppressNoItemsBanner == null))
                    this._config.SuppressNoItemsBanner = false;
                if (!this._config.hasOwnProperty('NoItemsLabelText') || (this._config.NoItemsLabelText == null))
                    this._config.NoItemsLabelText = 'STR_WPT_NO_ITEMS_AVAILABLE';
                if (!this._config.hasOwnProperty('UsePrimaryColour') || (this._config.UsePrimaryColour == null))
                    this._config.UsePrimaryColour = false;
                if (callback)
                    this._selectCallback = callback;
                if (!ComponentButtonPalette.Html) {
                    core.Loader.getVersionedHTML('widgets/components/buttonpalette.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            // Publish in case we want to hit with direct settings
            get Type() {
                return this._config.Type;
            }
            set Type(type) {
                this._config.Type = type;
            }
            get Orientation() {
                return this._config.Orientation;
            }
            set Orientation(orientation) {
                this._config.Orientation = orientation;
            }
            get VisibleCount() {
                this._log.info("ButtonPaletteComponent.VisibleCount()");
                let visibleOptions = this._buttonHolder.querySelectorAll('.' + OPTION_CLASS + ':not(.' + WPTNamespace.HIDDEN_CLASS + ')');
                return visibleOptions.length;
            }
            _present() {
                this._log.info("ButtonPaletteComponent._present()");
                if (!this._readyToPresent) {
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentButtonPalette.Html;
                this._buttonHolder = this._container.querySelector('#buttonPaletteHolder');
                this._noItems = this._container.querySelector('#buttonPaletteNoRecords');
                this._core.Helper.setElementTranslation(this._container.querySelector('#buttonPaletteNoRecordsLabel'), this._config.NoItemsLabelText);
                if (!this._config.SuppressNoItemsBanner)
                    this._core.Functions.showElement(this._noItems);
                this._componentReady = true;
                if (this._displayPending)
                    this._drawDisplay();
            }
        }
        ComponentButtonPalette.Html = null;
        Widgets.ComponentButtonPalette = ComponentButtonPalette;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
